import {ASSETS, BG, UPLOADS, GIPHY} from '../config/app.json'

/**
 * @summary constructs the image URL by prefixing the asset root
 * @param {string} type Type of the image
 * @param {string} subType SubType of the image
 * @param {string} src The src saved in the image
 * @returns {string} URL prefixed with asset URL
 */
export const getImageURL = (item, key) => {
    let type = item.get("type");
    let subType = item.get("subType");
    let src = item.get("src");
    let recentEdit = item.get("recentEdit");
    let sourceType = item.get("sourceType");
    if(type === "STOCKIMG" || type === "PEXELS" || type === "PIXABAY" || type === "UNSPLASH"){
        return src;
        // return "/getty/" + key + ".jpg";
    } else if (type === "IMG" && subType === "OBGIMG") {
        return `${ASSETS[ASSETS.current]}${BG.obgsrc}${src}`;
        // return "/getty/" + key + ".jpg";
    } else if (type === "UPLOADS" && subType === "UPIMAGE" && sourceType !== "gif" && sourceType.toLowerCase() !== "svg") {
        return `${UPLOADS.image_src}${src}`;
        // return "/getty/" + key + "." + item.get("sourceType");
    } else if (type === "UPLOADS" && subType === "UPIMAGE" && sourceType === "gif") {
        return `${UPLOADS.image_src}${src}`;
        // return "/getty/" + key + "." + item.get("sourceType");
    } else if (type === "UPLOADS" && subType === "UPIMAGE" && sourceType.toLowerCase() === "svg") {
        return `${UPLOADS.image_src}${src}`;
        // return "/getty/" + key + "." + item.get("sourceType");
    }
    if (subType === "GIPHY") {
        return GIPHY[GIPHY['workspace']] + item.get("src");
      }
    if (recentEdit) { 
        return UPLOADS.image_src + item.get("src");
    }

    return src;
}

/**
 * @summary constructs the thumbnail image URL by prefixing the asset root
 * @param {string} type Type of the image
 * @param {string} subType SubType of the image
 * @param {string} thumbSrc The thumbnail src saved in the image
 * @returns {string} URL prefixed with asset URL
 */
 export const getImageThumbnailURL = (type, subType, thumbSrc) => {

    if(type === "STOCKIMG" || type === "PEXELS" || type === "PIXABAY" || type === "UNSPLASH" || (type === "IMG" && subType === "GIPHY")){
        return thumbSrc;
    } else if (type === "IMG" && subType === "OBGIMG") {
        return `${ASSETS[ASSETS.current]}${BG.thumb}${thumbSrc}`;
    } else if (type === "UPLOADS" && subType === "UPIMAGE") {
        return `${UPLOADS.image_thumb}${thumbSrc}`;
    } else if(type === "STOCKVID" || type === "UPLOADS" || subType === "UPVIDEO") {
        if(subType === "UPVIDEO" && !thumbSrc.includes("https")) {
            thumbSrc = `${UPLOADS.image_thumb}${thumbSrc}`;
        }
        return thumbSrc;
    }

    return thumbSrc;
}


// WEBPACK FOOTER //
// ./src/helpers/URLHelper.js